import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/cameras/:cameraId/start-webrtc/';

type StartCameraWebRTCDTO = {
    parkingId: string;
    cameraId: number;
    data: string;
};

type StartCameraWebRTCResponse = {
    data: string;
};

export const startCameraWebRTC = ({
    parkingId,
    cameraId,
    data,
}: StartCameraWebRTCDTO): Promise<StartCameraWebRTCResponse> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, cameraId }), { data });
};

type StartCameraWebRTCFnType = typeof startCameraWebRTC;

interface USeStartCameraWebRTCOptions extends MutationConfig<StartCameraWebRTCFnType, GeneralSmartParkError> {}

export const useStartCameraWebRTC = (options: USeStartCameraWebRTCOptions = {}) =>
    useMutation({
        mutationFn: startCameraWebRTC,
        ...options,
    });
